let updateBlockStyles = () => {
  let items = document.querySelectorAll(`.header-with-border`);

  if ( items.length > 0 ) {
    items.forEach(el => {
      let color = el.getAttribute('data-border-color');
      console.log('color',el);
      el.style.setProperty('--borders-color', color);
    });

    return;
  } else {
    setTimeout(updateBlockStyles, 100);
  }
}

document.addEventListener('DOMContentLoaded', updateBlockStyles);